import { EmptyMessage } from '../../components/EmptyMessage';
import { ItemCard } from '../../components/ItemCard';
import { PageHeading } from '../../components/PageHeading';
import { PageSection } from '../../components/Section';
import { SkeletonCard } from '../../components/SkeletonCard';
import { TileGrid } from './GolfLandingTemplate.styles';
import type { GolfLandingTemplateProps } from './GolfLandingTemplate.types';

export function GolfLandingTemplate({
  heading,
  tiles,
  onSelectTile,
  isLoading,
  bookLabel = 'Book',
  noResultsLabel = 'Golf is not available at this property.',
  noImageLabel = 'No image',
}: GolfLandingTemplateProps) {
  if (isLoading && tiles.length === 0) {
    return (
      <PageSection>
        <PageHeading title={heading} />
        <TileGrid>
          {Array.from({ length: 3 }).map((_, index) => (
            <SkeletonCard key={index} variant="grid" />
          ))}
        </TileGrid>
      </PageSection>
    );
  }

  if (!isLoading && tiles.length === 0) {
    return (
      <PageSection>
        <PageHeading title={heading} />
        <EmptyMessage>{noResultsLabel}</EmptyMessage>
      </PageSection>
    );
  }

  return (
    <PageSection>
      <PageHeading title={heading} />
      <TileGrid>
        {tiles.map((tile) => (
          <ItemCard
            key={tile.id}
            image={{ src: tile.imageUrl, alt: tile.title, placeholderLabel: noImageLabel }}
            imageAspectRatio="1 / 1"
            title={tile.title}
            meta={tile.description}
            action={{ label: tile.ctaLabel ?? bookLabel, onClick: () => onSelectTile(tile.id) }}
            ariaLabel={tile.title}
            onSelect={() => onSelectTile(tile.id)}
          />
        ))}
      </TileGrid>
    </PageSection>
  );
}
